import { Phone, Clock, MapPin, Instagram, Truck, Shield, RotateCcw, Sparkles } from 'lucide-react';

const Footer = () => {
  const whatsappNumber = '917021703587';
  const instagramUrl = 'https://www.instagram.com/midha_thedesignerblouse?igsh=MWV2cjBkMXRxcDN5Nw==';
  const googleMapsUrl = 'https://maps.app.goo.gl/jureUEhA7ByoDBoF8';

  return (
    <footer className="bg-[#1A1A1A] text-white" data-testid="footer">
      {/* Trust Strip */}
      <div className="border-b border-gray-700/50">
        <div className="max-w-7xl mx-auto px-4 py-5">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div className="flex flex-col items-center gap-1.5">
              <Sparkles size={18} className="text-[#A85A52]" />
              <span className="text-xs text-gray-300 font-medium">Premium Fabrics</span>
            </div>
            <div className="flex flex-col items-center gap-1.5">
              <Shield size={18} className="text-[#A85A52]" />
              <span className="text-xs text-gray-300 font-medium">Quality Guaranteed</span>
            </div>
            <div className="flex flex-col items-center gap-1.5">
              <Truck size={18} className="text-[#A85A52]" />
              <span className="text-xs text-gray-300 font-medium">Worldwide Shipping</span>
            </div>
            <div className="flex flex-col items-center gap-1.5">
              <RotateCcw size={18} className="text-[#A85A52]" />
              <span className="text-xs text-gray-300 font-medium">Easy Exchange</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-xl font-bold text-[#A85A52] mb-3">MIDHA</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              The Designer Blouse — Exclusive collection of ready-to-wear designer blouses for all occasions.
            </p>
            <div className="flex gap-3">
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 rounded-full flex items-center justify-center hover:scale-110 transition-transform"
                data-testid="footer-instagram-link"
              >
                <Instagram size={16} />
              </a>
              <a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-[#25D366] rounded-full flex items-center justify-center hover:scale-110 transition-transform"
                data-testid="footer-whatsapp-link"
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-3">Contact Us</h3>
            <ul className="space-y-2.5 text-sm text-gray-400">
              <li className="flex items-start gap-2.5">
                <Phone size={15} className="text-[#A85A52] flex-shrink-0 mt-0.5" />
                <a href="tel:+917021703587" className="hover:text-[#A85A52] transition-colors" data-testid="footer-phone">
                  +91 70217 03587
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <svg viewBox="0 0 24 24" width="15" height="15" fill="#A85A52" className="flex-shrink-0 mt-0.5">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" className="hover:text-[#A85A52] transition-colors">
                  WhatsApp: +91 70217 03587
                </a>
              </li>
            </ul>
          </div>

          {/* Timing */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-3">Store Timing</h3>
            <div className="flex items-start gap-2.5 text-sm text-gray-400">
              <Clock size={15} className="text-[#A85A52] flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-medium text-white">Monday - Sunday</p>
                <p data-testid="footer-timing">11:00 AM - 9:30 PM</p>
              </div>
            </div>
          </div>

          {/* Address */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-3">Store Address</h3>
            <div className="flex items-start gap-2.5 text-sm text-gray-400">
              <MapPin size={15} className="text-[#A85A52] flex-shrink-0 mt-0.5" />
              <div data-testid="footer-address">
                <p>Shop No 37, 38, 39,</p>
                <p>Nakshtra Shopping Centre,</p>
                <p>Ranade Rd, Dadar West,</p>
                <p>Mumbai, Maharashtra 400028</p>
                <a
                  href={googleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#A85A52] hover:underline mt-1.5 inline-block text-xs font-medium"
                  data-testid="footer-directions-link"
                >
                  Get Directions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-gray-700/50">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-gray-500">
            <p>&copy; 2026 MIDHA - The Designer Blouse. All Rights Reserved.</p>
            <div className="flex gap-5">
              <span className="hover:text-gray-300 cursor-pointer transition-colors">Terms & Conditions</span>
              <span className="hover:text-gray-300 cursor-pointer transition-colors">Privacy Policy</span>
              <a href="/admin" className="hover:text-gray-300 transition-colors" data-testid="footer-admin-link">Admin</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
